import { ApiTags } from 'src/services/api';
import { auditLogApi } from 'src/services/api/auditLogApi';
import { AppDispatch } from 'src/store/configureStore';

import { Events } from '../constants/webSocketConsts/events';

export function handleAuditLogUpdate(
  _: Events,
  items: unknown[],
  dispatch: AppDispatch,
) {
  if (items.length > 0) {
    dispatch(
      auditLogApi.util.invalidateTags([
        { type: ApiTags.auditLogs, id: 'LIST' },
      ]),
    );
  }
}
